/**
 * Application-wide constants.
 * Update GOOGLE_FORM_URL with your actual Google Form link before deploying.
 */
// export const GOOGLE_FORM_URL = "https://forms.gle/your-form-link-here";

export const BOARD_YEAR = "2026/27";

export const CLUB_NAME = "Leo Club";

export const DEADLINE_DATE = "2026-06-08T23:59:59"; // Format: YYYY-MM-DDTHH:mm:ss
